"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const next_components_custom_link_1 = __importDefault(require("@gerenciatd/next.components.custom-link"));
const next_components_icon_label_n_1 = __importDefault(require("@gerenciatd/next.components.icon-label-n"));
const next_app_controller_reducers_sagas_modals_reducer_1 = require("@gerenciatd/next.app-controller.reducers-sagas.modals-reducer");
const constants_1 = require("../../constants");
const SegmentHandler = ({ segment, taggingInfo, addModal }) => {
    let segmentList2Use = '';
    let item2Putfirst = null;
    if (segment === 'empresas') {
        segmentList2Use = constants_1.SEGMENT_LIST_EMP;
        segmentList2Use = constants_1.SEGMENT_LIST_EMP.filter((item) => item.id !== segment);
        item2Putfirst = constants_1.SEGMENT_LIST_EMP.find((item) => item.id === segment);
    }
    else {
        segmentList2Use = constants_1.SEGMENT_LIST_GP;
        segmentList2Use = constants_1.SEGMENT_LIST_GP.filter((item) => item.id !== segment);
        item2Putfirst = constants_1.SEGMENT_LIST_GP.find((item) => item.id === segment);
    }
    if (item2Putfirst) {
        segmentList2Use.unshift(item2Putfirst);
    }
    const mySegmentList = constants_1.SEGMENT_LIST_GP.filter((item) => item.id !== segment);
    // const item2Putfirst = SEGMENT_LIST_GP.find(item => item.id === segment);
    mySegmentList.unshift(item2Putfirst);
    const cssSegment = ` ${segment}`;
    return (react_1.default.createElement("div", { className: `SegmentHandler${cssSegment}` }, mySegmentList.map((itemSegment) => {
        const { id, label, link } = itemSegment;
        const isActive = id === segment;
        const svgId = isActive ? 'CheuronUp' : '';
        const currentColor = isActive ? 'black' : 'blue';
        const currentLink = isActive ? '' : link;
        const handleModal = isActive
            ? () => addModal({
                type: next_app_controller_reducers_sagas_modals_reducer_1.ELEMENT_TYPES.MODAL,
                id: '',
            })
            : () => addModal({
                type: next_app_controller_reducers_sagas_modals_reducer_1.ELEMENT_TYPES.MODAL,
                id: 'segmentHandler',
            });
        return (react_1.default.createElement(next_components_custom_link_1.default, { key: `${id}-${label}`, onClick: handleModal, className: "link2sseg", title: "ver segmentos", ariaLabel: "ver segmentos", forceExternal: true, href: currentLink, taggingInfo: Object.assign(Object.assign({}, taggingInfo), { componentProduct: '', componentContent: `deplegable-segmento-${id}`, componentVariation: 'all-mobile' }) },
            react_1.default.createElement(next_components_icon_label_n_1.default, { id: svgId, label: label, labelSize: 16, labelColor: currentColor, iconColor: currentColor, iconSize: 12, labelPosition: "left", className: "cheuronSS", labelFont: "font-regular" })));
    })));
};
const mapDispatchToProps = (dispatch) => ({
    addModal: (data) => dispatch(next_app_controller_reducers_sagas_modals_reducer_1.actions.addModal(data)),
});
exports.default = (0, react_redux_1.connect)(null, mapDispatchToProps)(SegmentHandler);
//# sourceMappingURL=index.js.map